import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { secondaryBase } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';
import { DateRangePicker } from './date-range-picker';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <Group gap={24}>
      <Group gap={8}>
        <Icon name="auto_graph" size={32} color={secondaryBase} />
        <Text size="large" weight="medium">
          {t('process_analysis.title')}
        </Text>
      </Group>

      <DateRangePicker />
    </Group>
  );
};
